module.exports = __webpack_public_path__ + "img/Surface1.d3c6ac9e.jpg";